import { TableHead as MuiTableHead, TableRow } from '@mui/material';
import type { Sort } from 'app/common/types';
import type React from 'react';
import HeaderCell from './table-cells/header-cell';
import type { TableColumn } from './types';

export type TableHeadProps = {
  readonly columns: Array<TableColumn | string>;
  readonly tableName: string;
  readonly updateSort?: (sort: Sort) => void;
  readonly sort?: Sort;
};

const TableHead: React.FC<TableHeadProps> = (props: TableHeadProps) => {
  const { columns, tableName, updateSort, sort } = props;

  const tableColumns = columns.map((column) => {
    let name = '';
    let title = '';
    if (typeof column === 'string') {
      name = column;
      title = column;
    }

    if (typeof column === 'object') {
      name = column.name;
      title = column.title ? column.title : column.name;

      if (column.headerComponent) {
        return (
          <column.headerComponent
            tableName={tableName}
            key={name}
            name={name}
            title={title}
            updateSort={updateSort}
            sort={sort}
          />
        );
      }
    }

    return (
      <HeaderCell key={name} name={name} title={title} tableName={tableName} updateSort={updateSort} sort={sort} />
    );
  });

  return (
    <MuiTableHead>
      <TableRow>{tableColumns}</TableRow>
    </MuiTableHead>
  );
};

export default TableHead;
